import { Modal } from './Modal';
import { formatShortcut, type ShortcutDef } from '../../hooks/useKeyboardShortcuts';

interface ShortcutHelpModalProps {
  isOpen: boolean;
  onClose: () => void;
  shortcuts: ShortcutDef[];
}

export function ShortcutHelpModal({ isOpen, onClose, shortcuts }: ShortcutHelpModalProps) {
  const groups = shortcuts.reduce<Record<string, ShortcutDef[]>>((acc, s) => {
    (acc[s.group] ??= []).push(s);
    return acc;
  }, {});

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Keyboard Shortcuts" titleClassName="font-bold text-lg mb-4">
      {Object.entries(groups).map(([group, items]) => (
        <div key={group} className="mb-4">
          <h3 className="text-sm font-semibold text-base-content/70 uppercase tracking-wide mb-2">
            {group}
          </h3>
          <div className="space-y-2">
            {items.map((s) => (
              <div key={s.key} className="flex items-center justify-between">
                <span className="text-sm text-base-content">{s.label}</span>
                <kbd className="kbd kbd-sm">{formatShortcut(s.key)}</kbd>
              </div>
            ))}
          </div>
        </div>
      ))}

      <p className="text-xs text-base-content/70 mt-4">
        Single-key shortcuts are disabled when an input field is focused.
      </p>

      <div className="modal-action">
        <button type="button" className="btn btn-ghost btn-sm" onClick={onClose}>
          Close
        </button>
      </div>
    </Modal>
  );
}
